import React from 'react';
import { AutoComplete, Input } from 'antd';
import { Search } from 'lucide-react';
import { Toolbar } from '../../common';
import { usePriceSearch } from './priceElements.controller';

/** Toolbar above the price-list table: name search with suggestions; `right` holds extra actions. */
function PriceTableActions({ setRows, prices, right = null }) {
    const { searchValue, setSearchValue, suggestions, onSearch } = usePriceSearch({ setRows, prices });

    return (
        <Toolbar
            className="px-5 pt-4"
            left={
                <AutoComplete
                    value={searchValue}
                    options={suggestions.map((value) => ({ value }))}
                    onSearch={onSearch}
                    onSelect={onSearch}
                    onChange={(value) => setSearchValue(value)}
                    className="w-full sm:w-72">
                    <Input placeholder="Buscar lista de precio..." prefix={<Search className="text-surface-400" />} allowClear />
                </AutoComplete>
            }
            right={right}
        />
    );
}

export default PriceTableActions;
